const placeTextAds = (storyCards, isDesktop) => {
  let index = 0;
  let wordCount = 0;
  const updatedStoryCards = [];
  const wordLimit = isDesktop ? 70 : 50;

  const getWordCount = (htmlString) => {
    const regex = /(<([^>]+)>)/gi;
    const result = htmlString.replace(regex, "");
    return (result.match(/\b[$]?[\w.-]+\b/g) || []).length;
  };

  const splitHtmlByTags = (htmlString) => {
    const tagBlocks = [];
    const regex = /(<([^>\s]+)(?:\s[^>]*)?>.*?<\/\2>|<[^>\s]+(?:\s[^>]*)?\/?>)/gi;
    let match;
    while ((match = regex.exec(htmlString)) !== null) {
      tagBlocks.push(match[0]);
    }
    return tagBlocks;
  };

  for (const card of storyCards) {
    const updatedCardElements = [];
    for (const element of card["story-elements"]) {
      if (element.type === "text" && element?.text && !element.subtype) {
        const paragraphs = splitHtmlByTags(element.text);
        let updatedText = "";

        const excludedTags = ["h2"];

        for (const paragraph of paragraphs) {
          const tagMatch = paragraph.match(/^<(\w+)/i);
          const tagName = tagMatch ? tagMatch[1].toLowerCase() : null;

          updatedText += paragraph;

          if (excludedTags.includes(tagName)) continue;

          const paragraphWordCount = getWordCount(paragraph);
          wordCount += paragraphWordCount;

          if (wordCount >= wordLimit) {
            updatedText += `<p>${JSON.stringify({ flag: "ad_goes_here", index })}</p>`;
            index++;
            wordCount = 0;
          }
        }

        updatedCardElements.push({ ...element, text: updatedText });
      } else if (element.subtype === "summary" || element.type === "title") {
        wordCount += 0;
        updatedCardElements.push(element);
      } else {
        wordCount += 30;
        updatedCardElements.push(element);

        if (wordCount >= wordLimit) {
          updatedCardElements.push({ type: "ad", subtype: "ad", adIndexNo: index });
          index++;
          wordCount = 0;
        }
      }
    }

    updatedStoryCards.push({
      ...card,
      "story-elements": updatedCardElements,
    });
  }

  return updatedStoryCards;
};

const placeMagazineAds = (storyCards, isDesktop, member) => {
  if (member && member?.id) {
    return placeTextAds(storyCards, isDesktop);
  }
  return storyCards;
};

export const modifyStory = (story, isDesktop, member) => {
  const adsPlacementWrapper = {
    text: placeTextAds,
    magazine: placeMagazineAds,
    sponsored: placeTextAds,
    default: placeTextAds,
  };
  const newCards = (adsPlacementWrapper[story["story-template"]] || adsPlacementWrapper.default)(
    story.cards,
    isDesktop,
    member
  );
  return { ...story, cards: newCards };
};
